import { UseMutationResult, useMutation } from 'react-query';

import { getTokenWithType } from './useAuth';

import { exportCustomTable } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

function downloadFile(responseContent: any) {
  const byteCharacters = atob(responseContent.FileContentStream);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: responseContent.ContentType });

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${responseContent.FileName}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

async function exportCustomTableRecords({
  accountId,
  lookupId,
}: TVariables): Promise<TResult> {
  const response = await fetch(exportCustomTable(accountId, lookupId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: {
    FileContentStream: string;
    FileName: string;
    ContentType: string;
  };
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  lookupId: string | undefined;
};

type TSnapshot = unknown;

function useExportCustomTable(): UseMutationResult<
  void,
  TError,
  TVariables,
  TSnapshot
> {
  return useMutation(async (params: TVariables): Promise<void> => {
    if (params.lookupId === undefined) return;
    else {
      const formData = await exportCustomTableRecords(params);
      if (formData.Data) {
        downloadFile(formData.Data);
      } else if (formData.Errors) throw formData;
      return;
    }
  });
}

export { useExportCustomTable };
